import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import { SearchQuery, SearchItem } from '@/model/search/search-query'
import fetchConvo from './fetch-convo'
import fetchConvos from './fetch-convos'
import authStore from '@/store/auth/auth-store'
import feedStore from '@/store/feed/feed-store'

export default async function setConvoQuery(context: BareActionContext<ConvoState, RootState>)
{
    if(feedStore.feedId) {
        fetchConvo(context, feedStore.feedId)
        return
    }

    const searchForm = convoStore.state.convoSearchForm
    let query = new SearchQuery()
    query.sort = ['createdAt']
    query.descending = true

    let createdBy: string|null = null
    const tags = searchForm.tags
    console.log('setConvoQuery: feed user = %j', feedStore.state.feedUserId)
    console.log('setConvoQuery: auth user = %j', authStore.state.user)

    if (searchForm.createdByUser && feedStore.feedUserId) createdBy = feedStore.feedUserId.toString()
    else if (searchForm.createdByFollowing) createdBy = 'followed'
    else if (searchForm.createdByMe) createdBy = 'me'

    if (createdBy) {
        query.searchItems.push(new SearchItem('createdby', 'id', createdBy, null, null, null))
    }

    if (searchForm.likedByUser && feedStore.feedUserId) {
        query.searchItems.push(new SearchItem('likedby', 'id', feedStore.feedUserId.toString(), null, null, null))
    } 

    if (searchForm.likedByFollowing) {
        query.searchItems.push(new SearchItem('likedby', 'id', 'followed', null, null, null))
    }

    if (searchForm.likedByMe) {
        query.searchItems.push(new SearchItem('likedby', 'id', 'me', null, null, null))
    } 

    if (searchForm.followedByMe) {
        query.searchItems.push(new SearchItem('followedby', 'id', 'me', null, null, null))
    } 

    for(let i=0; i<tags.length; i++) {
        query.searchItems.push(new SearchItem('hastag', 'name', tags[i], null, null, null))
    }
    convoStore.commitSetQuery({ query: query })
    fetchConvos(context)

    return
}
